<template>
    <div class="cart-header">
        <img :src="cart.distributorLogo" class="dist-logo"/>
        <div v-if="!cart.pickupLocation">
            <div>{{cart.distributorName}}</div>
            <div>{{cart.distAddress1}}</div>
            <div v-if="cart.distAddress2">{{cart.distAddress2}}</div>
            <div>{{cart.distAddress3}}</div>
        </div>

        <div style="clear:both"><b>Pickup: {{displayDateTime(cart.pickup)}}
            <span v-if="cart.pickupLocation"> at {{cart.pickupLocation}}</span>
        </b></div>
    </div>

</template>

<script>
    import dateHelper from "../services/dateHelper";
    export default {
        name: 'cart-header',
        props: {
            cart: {
                type: Object,
                default: null
            }
        },
        methods: {
            displayDateTime(date) {
                return dateHelper.displayDateTime(date)
            }
        }
    }
</script>
<style scoped>
    .dist-logo {
        max-height: 100px;
        float: left;
        padding-right: 25px;
    }

    .cart-header {
        min-height: 125px;
    }

</style>
